/*
 * @Author: your name
 * @Date: 2022-04-26 15:46:16
 * @LastEditTime: 2024-12-03 17:23:19
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /yach_31_record/packages/auxiliary_ability/src/store/autoStore/index.ts
 */
import { makeAutoObservable, action } from 'mobx';
import { isPlainObject } from 'lodash-es';
import { message } from 'antd';

// import { setLocalStorage, getLocalStorage } from '@utils/methods'

import request from '@utils/request';

export class AuthStore {
    /**
     * token
     */
    // token: string = getLocalStorage('accessToken')
    // authConfig: IAuthStore.autoConfigParams = getLocalStorage('accessAuthConfig') ? JSON.parse(getLocalStorage('accessAuthConfig')) : null
    token: string = '';
    authConfig: IAuthStore.autoConfigParams = null;
    
    constructor() {
        makeAutoObservable(this);
    }

    @action
    getToken = async (params: IAuthStore.LoginParams) => {
        try {
            // const { code } = await getAuthCode(params)
            const code = 'test';
            const getTokenParams = {
                code,
                url: encodeURIComponent(location.href.replace(location.hash, '')),
            };

            const data: any = await request.post<IAuthStore.UserInfo>(
                `/usergroup/group/getjstoken`,
                getTokenParams
            );
       
            const res = isPlainObject(data) ? data : null;
            this.setToken(res);
            return res;
        } catch (e) {
            message.error(e);
        }

        return null;
    };

    @action
    setTokenMock = (tokenStr) => {
        this.token = tokenStr;
    };

    /**
     * 初始化用户信息
     *
     * @memberof AuthStore
     */
    @action
    setToken = (userInfo: IAuthStore.UserInfo): IAuthStore.UserInfo => {
        this.token = userInfo?.obj?.data?.token;
        this.authConfig = userInfo?.obj?.data;
        // setLocalStorage('accessToken', this.token)
        // setLocalStorage('accessAuthConfig', JSON.stringify(this.authConfig))
        return userInfo;
    };
}

export default new AuthStore();
